
<template>
    <div style="padding: 20px;">
        <div class="sletop" >
            <div class="span_time" >
                <span >时间</span>
                <span class="span_input">{{timeRange}}</span>
            </div>
            <div class="but_span">
                <span  @click="switchBut(0)" :class="current==0?'currentspan':''">当月数据</span>
                <span  @click="switchBut(1)" :class="current==1?'currentspan':''">本季度数据</span>
                <span  @click="switchBut(2)" :class="current==2?'currentspan':''">本年度数据</span>
                <span  @click="switchBut(3)" :class="current==3?'currentspan':''">历史累计数据</span>
            </div>
        </div>
        <div class="infocity">
            <div style="display: flex;">
               地区：
                <span @click="goback(2)" :style="{'color':cityName!=''?'#4e8ed6':''}" >全国</span>
                <div v-if="cityName!=''">
                    >
                    <span @click="goback(1)" :style="{'color':areaName!=''?'#4e8ed6':''}" >{{cityName}}</span>
                </div>
                <div v-if="areaName!=''">
                    >
                    <span >{{areaName}}</span>
                </div>
            </div>
            <div>
                <el-button class="m-l-2" @click="goback(1)" v-if="type!=1">返回上级</el-button>
                <el-button v-show="hideExport" style="margin-right:0px;" @click="exportDate">导出</el-button>
            </div>
            
        </div>
        <div class="tabdata">
            <div class="tabitem" v-for="(item,index) in listData" :key="index" style="margin-bottom: 20px;">
                <span class="tabtitle" v-if="item.name=='合计'">{{item.name}}</span>
                <span class="tabtitle" v-else  :style="{'color':type!=3?'#4e8ed6':''}" @click="cityClick(item.code,item.name)">{{item.name}} <a v-if="type!=3">>></a> </span>
                <el-table ref="singleTable" :data="item.itemData" :span-method="arraySpanMethod" border  empty-text="暂无相关信息" :header-cell-style="{background:'#eef1f6',color:'#606266'}"      style="width: 100%" >
                    <el-table-column property="liveness" label="活跃度 " width="120"  align="center">
                        <template slot-scope="scope">
                            <div>
                              <span style="margin-right: 74px;color: rgb(65, 184, 131);font-weight: 550;">{{format(scope.row.liveness)}}%</span>  <span style="font-weight: 550;"> = &nbsp; {{format(scope.row.cardCount)}} &nbsp; / &nbsp; {{format(scope.row.countTotal)}}</span> 
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="cardCount" label="消费卡数 / 历史累计发卡数"  width="190"   align="center">
                        
                    </el-table-column>
                    <el-table-column property="count" label="发卡量（万张）"  align="center" >
                       <template slot-scope='scope'>
                          <span style="color: rgb(65, 184, 131);font-weight: 550;">{{format(scope.row.count)}}</span>  
                        </template>
                    </el-table-column>
                    <el-table-column property="litter" label="消费量（万吨）"   align="center">
                        <template slot-scope='scope'>
                           <span style="color: rgb(65, 184, 131);font-weight: 550;">{{format(scope.row.litter)}}</span> 
                        </template>
                    </el-table-column>
                    <el-table-column property="cardCount" label="消费卡数量（万张）"  align="center" >
                        <template slot-scope='scope'>
                           <span style="color: rgb(65, 184, 131);font-weight: 550;">{{format(scope.row.cardCount)}}</span> 
                        </template>
                    </el-table-column>
                    <el-table-column property="abnormalCount" label="异常消费卡数（万张）" align="center" >
                        <template slot-scope='scope'>
                           <span style="color: rgb(65, 184, 131);font-weight: 550;">{{format(scope.row.abnormalCount)}}</span> 
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
  
</template>

<script>
import Cookies from 'js-cookie'
import http from '@/api/cardData'
import { hideExport } from '@/utils/tools'
export default {
     data () {
        return {
            hideExport:hideExport,
            timeRange:'',
            listData:[],
            current:'0',//统计类型0：月度，1：季度，2：年度，3：历史累计
            type:1,//查询类型，1:省份，2：地市，3：网点
            code:'',
            gobackCode:'',
            cityName:'',
            areaName:''
        }
    },
    watch:{
        
    },
    
    mounted() {
        this.getListData();
    },
    methods: {
         arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (rowIndex % 2 === 0) {
                if (columnIndex === 0) {
                    return [1, 2];
                } else if (columnIndex === 1) {
                    return [0, 0];
                }
            }
        },
        getListData(search = false){
           
            http[0].operatorSiteCount({
                "type":this.type,
                "countType": this.current,
                "code":this.code
            }).then(e=>{
                let list = [];
                for(let i in e.data){
                    list.push({
                        name:e.data[i].name,
                        code:e.data[i].code,
                        itemData:[e.data[i]]
                    })
                }
                this.listData = list
                this.timeRange = e.timeRange
            })
        },
        switchBut(a){
            this.current = a;
            this.getListData();
        },
        cityClick(a,b){
            if(this.type<3){
                this.type = this.type + 1;
                this.gobackCode = this.code;
                this.code = a;
                if(this.type==2){
                    this.cityName = b;
                }else{
                    this.areaName = b;
                }
                this.getListData();
            }
        },
        goback(a){
            this.type = this.type - a <=0?1:this.type - a;
            if(this.type == 1){
                this.code = '';
                this.cityName = '';
                this.areaName = '';
            }else{
                this.areaName = '';
                this.code = this.gobackCode;
            }
            this.getListData();
        },
        carCardDetails(a){
            let obj = {
                value:this.value,
                vehicleNumber:this.vehicleNumber,
                orderType:this.orderType,
                pageNo:this.pageNo,
                pageSize:this.pageSize,
            }
            sessionStorage.setItem('objData',JSON.stringify(obj))
             this.$router.push({
                name: 'cardDetails',
                query: {
                    carNum:a,
                    time:this.dateTime
                }
            })
        },
   
        exportDate(){
            //"type":"1","countType":"1","code":"15"
            window.location.assign(`/bi-api/operatorSiteCount/listExport?type=${this.type}&countType=${this.current}&code=${this.code}`)
        },
        format(num) {
            var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                    return $1+",";
                });
            })
            return res;
        },
    }
}
</script>

<style  scoped>
.sletop{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}
.span_time{
    display: flex;
    align-items: center;
}
.span_time span{
    cursor: default;
    font-size: 15px;
}
.span_input{
    display: inline-block;
    width: 280px;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    background: #fff;
    margin-left: 8px;
    border:1px solid #dcdfe6;
}
.but_span{
    margin-left: 50px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 550;
    color: rgb(96, 98, 102);
    /* border:1px solid #dcdfe6; */
    border-radius: 4px;
}
.but_span span{
    display: inline-block;
    padding: 6px 18px;
    border-left: 1px solid #dcdfe6;
    border:1px solid #dcdfe6;
}
.infocity{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    margin-bottom: 10px;
    font-weight: 550;
    color: rgb(96, 98, 102);
}
.tabdata{
    background: #fff;
    padding: 16px;
}
.tabitem{
    /* margin-top: 10px; */
}
.tabtitle{
    margin: 10px 0;
    display: inline-block;
    font-size: 15px;
}
.currentspan{
    background: #4e8ed6;
    color: #fff;
    border:1px solid #4e8ed6  !important;
}
</style>
